import { ISize, NodeKind, IColor, IGuideline, IGifExport, IPreloadImage, ChangeEventCallback, IBorder, ICreativeSocialGuide } from '@studio/domain';
import { BaseDataNodeWithChildren, IBaseDataNodeWithChildrenInput } from './base-data-node';
import { fromRGBAstring } from '@creative/color.utils';

/* webpack-strip-block:removed */

export class CreativeDataNode extends BaseDataNodeWithChildren<NodeKind.Creative> implements ISize {
    /**
     * These properites are obsolete for the
     * creative data node but gets inherited from the base
     * They are deleted in the constructor
     */
    name: any;
    locked: any;
    hidden: any;
    /** ----- */

    fill: IColor;
    radius: number;
    loops = 0;
    stopTime?: number;
    startTime?: number;
    border?: IBorder<IColor>;
    width: number;
    height: number;
    noEmit = false;
    callbacks: ChangeEventCallback[] = [];
    guidelines: IGuideline[] = [];
    preloadImage: IPreloadImage;
    gifExport: IGifExport;
    textColor: IColor;
    socialGuide?: ICreativeSocialGuide;

    get duration(): number {
        return this._duration;
    }

    constructor(creative: ICreativeInput) {
        super({ ...creative, kind: NodeKind.Creative, nodes: creative.nodes });
        delete this.hidden;
        delete this.locked;
        delete this.name;
        this.width = creative.width;
        this.height = creative.height;
        this.fill = creative.fill || fromRGBAstring('rgba(255, 255, 255, 1)');
        this.textColor = creative.textColor || fromRGBAstring('rgba(0, 0, 0, 1)');
        this.radius = creative.radius || 0;
        this.loops = creative.loops || 0;
        this.stopTime = creative.stopTime;
        this.startTime = creative.startTime;
        this.guidelines = creative.guidelines || [];
        this.gifExport = {
            frames: [],
            show: false,
            ...creative.gifExport
        };
        this.preloadImage = {
            quality: 70,
            format: 'jpg',
            frames: [],
            ...creative.preloadImage
        };
        this.socialGuide = creative.socialGuide;
    }

    /* webpack-strip-block:removed */

    getFirstPreloadImageFrame(): number {
        if (this.preloadImage.frames.length > 0) {
            return this.preloadImage.frames[0];
        }
        return 1;
    }

    getStopTime_m(): number {
        if (typeof this.stopTime === 'number') {
            return this.stopTime;
        }
        else {
            return this.duration - 1;
        }
    }

    subscribe_m(callback: ChangeEventCallback): void {
        this.callbacks.push(callback);
    }

    unsubscribe_m(callback?: ChangeEventCallback): void {
        if (!callback) {
            this.callbacks = [];
            return;
        }
        const index = this.callbacks.indexOf(callback);
        if (index !== -1) {
            this.callbacks.splice(index, 1);
        }
    }

    destroy_m(): void {
        this.callbacks = [];
    }
}


export interface ICreativeInput extends Omit<IBaseDataNodeWithChildrenInput, 'kind'> {
    width: number;
    height: number;
    fill?: IColor;
    textColor?: IColor;
    loops?: number;
    radius?: number;
    startTime?: number;
    stopTime?: number;
    guidelines?: IGuideline[];
    preloadImage?: IPreloadImage;
    gifExport?: IGifExport;
    socialGuide?: ICreativeSocialGuide;
}
